/**
* @file 战队-首页
* @author 余凯
*/

import React from 'react'

import { connect } from 'react-redux'
// import {getTeamBaseInfo, dispatchSetTeamInfo} from '@/redux/teamRedux'
import { getTeamBaseInfo, dispatchSetTeamInfo } from '@/redux/teamRedux'
import Info from './info'
import FormPage from './formPage'
import Actions from '@/apis/team'

@connect(
  state => state.teamReducer,
  { getTeamBaseInfo, dispatchSetTeamInfo }
)
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      own: 0,
      visible: false,
      showForm: false,
      teamInfo: {},
      rankList: [],
    }
  }

  callback(key) {
    // console.log(key);
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  componentDidMount() {
    this.getData()
    this.getRank()
  }

  handleGoForm = async () => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game
    }
    this.props.getTeamBaseInfo(params)
    this.setState({
      showForm: true
    })
  }

  onFormCancel = () => {
    this.setState({
      showForm: false
    })
  }

  onFormSubmit = (t) => {
    this.setState({
      showForm: false
    })
    setTimeout(() => {
      this.getData()
    }, 200)
  }

  getData =  () => {
    setTimeout(async () => {
      const params = {
        id: this.props.userInfo.game_team_id,
        game_id: this.props.game
      }
      Actions.getTeamDetail(params).then(res => {
        if (res.code == 200) {
          this.props.dispatchSetTeamInfo(res.data)
          this.setState({
            teamInfo: res.data
          })
        }
      })
    }, 0)
  }

  getRank = () => {
    setTimeout(async () => {
      const rankParams = {
        id: this.props.userInfo.game_team_id,
        game_id: this.props.game,
        type: 1,
        page_size: 10
      }
      Actions.getTeamRank(rankParams).then(res => {
        if (res.code == 200) {
          this.setState({
            rankList: res.data.list
          })
        }
      })
    }, 0)
  }

  render() {
    const { teamInfo, rankList, showForm }  = this.state
    return (
      <>
        {showForm
          ? <FormPage id={this.props.userInfo && this.props.userInfo.game_team_id} onFormCancel={this.onFormCancel} onFormSubmit={this.onFormSubmit} />
          : <Info teamInfo={teamInfo} rankList={rankList} id={this.props.userInfo && this.props.userInfo.game_team_id} onGoForm={this.handleGoForm} />}
      </>
    );
  }
}

export default Home;
